export const GENERIC_DISPOSITION_KEYS = [
    'QUALIFY',
    'UNQUALIFIED',
    'UNDETERMINED',
    'CALLBACK',
    'NOT_INTERESTED',
] as const;

export type GenericDispositionKey = (typeof GENERIC_DISPOSITION_KEYS)[number];

export const emptyDispositionLabels = (): Record<GenericDispositionKey, string> => ({
    QUALIFY: '',
    UNQUALIFIED: '',
    UNDETERMINED: '',
    CALLBACK: '',
    NOT_INTERESTED: '',
});

export const DISPOSITION_LABEL_MAX_LENGTH = 64;
const DISPOSITION_LABEL_PATTERN = /^[A-Za-z0-9]+(?:[ -][A-Za-z0-9]+)*$/;

export const validateDispositionLabel = (
    value: string,
    key: GenericDispositionKey,
    all: Record<GenericDispositionKey, string>
): true | string => {
    const trimmed = value?.trim();
    if (!trimmed) return true;

    if (trimmed.length > DISPOSITION_LABEL_MAX_LENGTH) {
        return `Must be ${DISPOSITION_LABEL_MAX_LENGTH} characters or fewer`;
    }

    if (!DISPOSITION_LABEL_PATTERN.test(trimmed)) {
        return 'Use letters, numbers, spaces, and hyphens only';
    }

    const lower = trimmed.toLowerCase();
    const duplicate = GENERIC_DISPOSITION_KEYS.some(
        (other) => other !== key && all[other]?.trim().toLowerCase() === lower
    );

    return duplicate ? 'This name is already used for another disposition' : true;
};
